
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/account-admin-tools/jst/authLoggingSearchResults';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n\n  <table class=\"ic-Table ic-Table--condensed\">\n    <thead>\n      <tr>\n        <th>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.auth_logging_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.auth_logging_search_results.date", "Date", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.auth_logging_search_results.date", "Date", options)))
    + "</th>\n        <th>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.auth_logging_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.auth_logging_search_results.time", "Time", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.auth_logging_search_results.time", "Time", options)))
    + "</th>\n        <th>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.auth_logging_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.auth_logging_search_results.activity", "Activity", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.auth_logging_search_results.activity", "Activity", options)))
    + "</th>\n      </tr>\n    </thead>\n    <tbody class=\"collectionViewItems\"></tbody>\n  </table>\n  <div class=\"paginatedLoadingIndicator\"></div>\n\n";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n\n  <div class=\"alert alert-info\">\n    <p class=\"lead\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.auth_logging_search_results")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.auth_logging_search_results.no_item_found", "No items found", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.auth_logging_search_results.no_item_found", "No items found", options)))
    + "</p>\n  </div>\n  <div class=\"paginatedLoadingIndicator\"></div>\n\n";
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.length), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n\n\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  